@if (showMyMeetingsRecordingTab$ | async) {
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a
      mat-tab-link
      [routerLink]="'bookings'"
      routerLinkActive
      #bookingRLA="routerLinkActive"
      [active]="bookingRLA.isActive"
      data-action="clicked-bookings-tab"
    >
      {{ 'COMMON.BOOKINGS' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="'recordings'"
      routerLinkActive
      #recordingRLA="routerLinkActive"
      [active]="recordingRLA.isActive"
      data-action="clicked-recordings-tab"
    >
      <div class="recording-tab">
        {{ 'COMMON.RECORDINGS' | translate }}
        @if (showTierUpgradeIcon()) {
          <mat-icon class="upgrade-icon">arrow_circle_up</mat-icon>
        }
      </div>
    </a>
  </nav>

  <mat-tab-nav-panel #tabPanel>
    <ng-container *ngTemplateOutlet="tabContent"></ng-container>
  </mat-tab-nav-panel>
} @else {
  <ng-container *ngTemplateOutlet="tabContent"></ng-container>
}

<ng-template #tabContent>
  @if (salesCoachUserConfig$ | async; as sccConfig) {
    <div
      class="content-wrapper"
      [class.has-alerts]="hasAnyAlert || !sccConfig.joinMeetings || (hasDisconnectedIntegrations$ | async)"
    >
      <div class="page-container">
        <!-- Integration Warnings (Calendar & Meeting App) -->
        <div class="integration-warnings">
          @if (isCalendarDisconnected$ | async) {
            <glxy-alert
              type="warning"
              [showAction]="true"
              actionTitle="Reconnect"
              (actionClick)="reconnectIntegrations()"
              data-action="reconnect-calendar"
            >
              <strong>{{ 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.CALENDAR_DISCONNECT' | translate }}</strong>
              {{ 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.CALENDAR_DISCONNECT_TEXT' | translate }}
            </glxy-alert>
          }

          @if (isMeetingAppDisconnected$ | async) {
            <glxy-alert
              type="warning"
              [showAction]="true"
              actionTitle="Reconnect"
              (actionClick)="reconnectIntegrations()"
              data-action="reconnect-meeting-app"
            >
              <strong>{{ 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.MEETING_APP_DISCONNECT' | translate }}</strong>
              {{ 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.MEETING_APP_DISCONNECT_TEXT' | translate }}
            </glxy-alert>
          }
        </div>

        @if (isBookingsActive && showBookingsAlert && sccConfig.joinMeetings) {
          <glxy-alert
            type="tip"
            [showClose]="true"
            (close)="onBookingsAlertClose()"
            data-action="dismissed-bookings-alert"
          >
            {{ 'MEETING_SCHEDULER.MY_MEETINGS.BOOKINGS_TIP' | translate }}
          </glxy-alert>
        }
        @if (isRecordingsActive) {
          @if (showTierUpgradeRequiredAlert()) {
            <glxy-alert
              type="success"
              icon="trending_up"
              [showAction]="true"
              [actionTitle]="'MEETING_SCHEDULER.MY_MEETINGS.TIER_UPGRADE_REQUIRED_ACTION' | translate"
              (actionClick)="comparePlans()"
              data-action="clicked-review-recording-settings"
            >
              <strong>{{ 'MEETING_SCHEDULER.MY_MEETINGS.TIER_UPGRADE_REQUIRED_TITLE' | translate }}</strong>
              &mdash;&nbsp;{{ 'MEETING_SCHEDULER.MY_MEETINGS.TIER_UPGRADE_REQUIRED_DESCRIPTION' | translate }}
            </glxy-alert>
          }
          @if (showRecordingDisabledAlert()) {
            <glxy-alert
              type="warning"
              icon="smart_display"
              [showAction]="true"
              [actionTitle]="'MEETING_SCHEDULER.MY_MEETINGS.REVIEW_SETTINGS' | translate"
              (actionClick)="navigateToSettings()"
              data-action="clicked-review-recording-settings"
            >
              {{ 'MEETING_SCHEDULER.MY_MEETINGS.RECORDING_OFF_WARNING' | translate }}
            </glxy-alert>
          }
          @if (showRecordingsDismissableAlert()) {
            <glxy-alert
              type="tip"
              [showClose]="true"
              (close)="onRecordingsAlertClose()"
              data-action="dismissed-recordings-alert"
            >
              {{ 'MEETING_SCHEDULER.MY_MEETINGS.RECORDINGS_TIP_PREFIX' | translate }}
              <a
                href="#"
                (click)="navigateToCrmRecordedMeetings(); $event.preventDefault()"
                class="alert-link"
                data-action="clicked-crm-activity-stream-link"
                >{{ 'MEETING_SCHEDULER.MY_MEETINGS.CRM_ACTIVITY_STREAM_LINK' | translate }}</a
              >{{ 'MEETING_SCHEDULER.MY_MEETINGS.RECORDINGS_TIP_SUFFIX' | translate }}
            </glxy-alert>
          }
        }
      </div>
      <router-outlet></router-outlet>
    </div>
  }
</ng-template>
